export default __webpack_public_path__ + "static/media/vrepo1.7e1d3abc.svg";